export default {
  LOGIN: "login",
  SELECT_LESSON_PAGE: "selectLessonPage",
  REPORT_CARD: "reportCard",
  LIBRARY: "library",
  CALENDAR: "calendar",
  JOURNAL: "journal",
  CLASS: "class",
  TEACHER_ROOM: "teacherRoom",
  PARENT_ROOM: "parentRoom",
  PARENT_DIARY: "parentDiary",
  PARENT_COURSE: "parentCourse",
  PARENT_LESSON: "parentLesson",
  ACTIVITY_CENTER: "activityCenter",
  SETTINGS: "settings",
  LESSON: "lesson",
};
